<script lang="ts">
  import { _ } from 'svelte-i18n';

  // Props
  export let email: string = '';
  export let label: string = '';
  export let placeholder: string = '';
  export let required: boolean = false;
  export let error: string = '';
  export let disabled: boolean = false;

  // Validate email format
  function validateEmail(value: string): boolean {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(value);
  }

  // Handle input change
  function handleInput(event: Event) {
    const target = event.target as HTMLInputElement;
    email = target.value;
  }
</script>

<div class="email-input">
  {#if label}
    <label for="emailInput">{label}</label>
  {/if}
  <input
    id="emailInput"
    type="email"
    bind:value={email}
    on:input={handleInput}
    {required}
    {placeholder}
    {disabled}
    aria-invalid={error ? 'true' : undefined}
  />
  {#if error}
    <small class="error-text">{error}</small>
  {/if}
</div>

<style>
  .email-input {
    width: 100%;
  }

  .error-text {
    color: var(--pico-del-color, #c62828);
    display: block;
    margin-top: 0.25rem;
  }
</style>
